var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMember(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Member, Property 2=Inactive"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 12C28 11.4477 28.4477 11 29 11H39C39.5523 11 40 11.4477 40 12V13C40 13.5523 39.5523 14 39 14H29C28.4477 14 28 13.5523 28 13V12ZM12 37C14.2091 37 16 35.2091 16 33C16 30.7909 14.2091 29 12 29C9.79086 29 8 30.7909 8 33C8 35.2091 9.79086 37 12 37ZM12 38C15.866 38 19 41.134 19 45H5C5 41.134 8.13401 38 12 38ZM29 16C28.4477 16 28 16.4477 28 17V18C28 18.5523 28.4477 19 29 19H39C39.5523 19 40 18.5523 40 18V17C40 16.4477 39.5523 16 39 16H29ZM28 22C28 21.4477 28.4477 21 29 21H39C39.5523 21 40 21.4477 40 22V23C40 23.5523 39.5523 24 39 24H29C28.4477 24 28 23.5523 28 23V22ZM29 26C28.4477 26 28 26.4477 28 27V28C28 28.5523 28.4477 29 29 29H39C39.5523 29 40 28.5523 40 28V27C40 26.4477 39.5523 26 39 26H29Z",
    fill: "#C3CBD3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 5C43.2091 5 45 6.79086 45 9V31C45 33.2091 43.2091 35 41 35H23C20.7909 35 19 33.2091 19 31V9C19 6.79086 20.7909 5 23 5H41ZM41 8H23C22.4872 8 22.0645 8.38604 22.0067 8.88338L22 9V31C22 31.5128 22.386 31.9355 22.8834 31.9933L23 32H41C41.5128 32 41.9355 31.614 41.9933 31.1166L42 31V9C42 8.48716 41.614 8.06449 41.1166 8.00673L41 8ZM24 12.5C24 11.6716 24.6716 11 25.5 11C26.3284 11 27 11.6716 27 12.5C27 13.3284 26.3284 14 25.5 14C24.6716 14 24 13.3284 24 12.5ZM25.5 16C24.6716 16 24 16.6716 24 17.5C24 18.3284 24.6716 19 25.5 19C26.3284 19 27 18.3284 27 17.5C27 16.6716 26.3284 16 25.5 16ZM24 22.5C24 21.6716 24.6716 21 25.5 21C26.3284 21 27 21.6716 27 22.5C27 23.3284 26.3284 24 25.5 24C24.6716 24 24 23.3284 24 22.5ZM25.5 26C24.6716 26 24 26.6716 24 27.5C24 28.3284 24.6716 29 25.5 29C26.3284 29 27 28.3284 27 27.5C27 26.6716 26.3284 26 25.5 26Z",
    fill: "#E0E4E7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMember);
export default __webpack_public_path__ + "static/media/member.fab4fc4c3d2dcbbaf682608a49e835b5.svg";
export { ForwardRef as ReactComponent };